/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateMerchantRequest,
  CreateStoreRequest,
  HttpValidationProblemDetails,
  InviteClientUserRequest,
  InviteClientUserResult,
  MerchantDetailDto,
  MerchantSummaryDto,
  PagedResultOfPortalClientUserDto,
  PagedResultOfTransactionSummaryDto,
  PortalClientDto,
  PortalClientUserDto,
  PortalGetPortalTransactionsParams,
  PortalGetPortalUsersParams,
  PortalSessionDto,
  StoreDetailDto,
  StoreSummaryDto,
  UpdateClientUserRequest,
  UpdateMerchantRequest,
  UpdateStoreRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Detail for the client the authenticated user belongs to.
 */
export const portalGetPortalMeClient = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalClientDto>({ url: `/portal/me/client`, method: 'GET', signal }, options);
};

export const getPortalGetPortalMeClientQueryKey = () => {
  return [`/portal/me/client`] as const;
};

export const getPortalGetPortalMeClientQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalMeClient>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMeClient>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalMeClientQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalMeClient>>> = ({
    signal,
  }) => portalGetPortalMeClient(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalMeClient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalMeClientQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalMeClient>>
>;
export type PortalGetPortalMeClientQueryError = unknown;

export function usePortalGetPortalMeClient<
  TData = Awaited<ReturnType<typeof portalGetPortalMeClient>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMeClient>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMeClient>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMeClient>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMeClient<
  TData = Awaited<ReturnType<typeof portalGetPortalMeClient>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMeClient>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMeClient>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMeClient>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMeClient<
  TData = Awaited<ReturnType<typeof portalGetPortalMeClient>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMeClient>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Detail for the client the authenticated user belongs to.
 */

export function usePortalGetPortalMeClient<
  TData = Awaited<ReturnType<typeof portalGetPortalMeClient>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMeClient>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalMeClientQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalGetPortalMerchants = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantSummaryDto[]>(
    { url: `/portal/merchants`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalMerchantsQueryKey = () => {
  return [`/portal/merchants`] as const;
};

export const getPortalGetPortalMerchantsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalMerchants>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchants>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalMerchantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalMerchants>>> = ({
    signal,
  }) => portalGetPortalMerchants(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalMerchants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalMerchantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalMerchants>>
>;
export type PortalGetPortalMerchantsQueryError = unknown;

export function usePortalGetPortalMerchants<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchants>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchants>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchants<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchants>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchants<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchants>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalMerchants<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchants>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalMerchantsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPostPortalMerchants = (
  createMerchantRequest: CreateMerchantRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/portal/merchants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMerchantRequest,
      signal,
    },
    options,
  );
};

export const getPortalPostPortalMerchantsMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalMerchants>>,
    TError,
    { data: CreateMerchantRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalMerchants>>,
  TError,
  { data: CreateMerchantRequest },
  TContext
> => {
  const mutationKey = ['portalPostPortalMerchants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalMerchants>>,
    { data: CreateMerchantRequest }
  > = (props) => {
    const { data } = props ?? {};

    return portalPostPortalMerchants(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalMerchantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalMerchants>>
>;
export type PortalPostPortalMerchantsMutationBody = CreateMerchantRequest;
export type PortalPostPortalMerchantsMutationError = HttpValidationProblemDetails;

export const usePortalPostPortalMerchants = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalMerchants>>,
      TError,
      { data: CreateMerchantRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalMerchants>>,
  TError,
  { data: CreateMerchantRequest },
  TContext
> => {
  const mutationOptions = getPortalPostPortalMerchantsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalMerchantsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/portal/merchants/${id}`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalMerchantsIdGuidQueryKey = (id?: string) => {
  return [`/portal/merchants/${id}`] as const;
};

export const getPortalGetPortalMerchantsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalMerchantsIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>> = ({
    signal,
  }) => portalGetPortalMerchantsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalMerchantsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>
>;
export type PortalGetPortalMerchantsIdGuidQueryError = unknown;

export function usePortalGetPortalMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalMerchantsIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalMerchantsIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPutPortalMerchantsIdGuid = (
  id: string,
  updateMerchantRequest: UpdateMerchantRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/portal/merchants/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMerchantRequest,
    },
    options,
  );
};

export const getPortalPutPortalMerchantsIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>,
    TError,
    { id: string; data: UpdateMerchantRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>,
  TError,
  { id: string; data: UpdateMerchantRequest },
  TContext
> => {
  const mutationKey = ['portalPutPortalMerchantsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>,
    { id: string; data: UpdateMerchantRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return portalPutPortalMerchantsIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPutPortalMerchantsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>
>;
export type PortalPutPortalMerchantsIdGuidMutationBody = UpdateMerchantRequest;
export type PortalPutPortalMerchantsIdGuidMutationError = HttpValidationProblemDetails;

export const usePortalPutPortalMerchantsIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>,
      TError,
      { id: string; data: UpdateMerchantRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPutPortalMerchantsIdGuid>>,
  TError,
  { id: string; data: UpdateMerchantRequest },
  TContext
> => {
  const mutationOptions = getPortalPutPortalMerchantsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalMerchantsIdGuidSuspend = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/portal/merchants/${id}/suspend`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalMerchantsIdGuidSuspendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalMerchantsIdGuidSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalMerchantsIdGuidSuspend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalMerchantsIdGuidSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>
>;

export type PortalPostPortalMerchantsIdGuidSuspendMutationError = unknown;

export const usePortalPostPortalMerchantsIdGuidSuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalMerchantsIdGuidSuspendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalMerchantsIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/portal/merchants/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalMerchantsIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalMerchantsIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalMerchantsIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalMerchantsIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>
>;

export type PortalPostPortalMerchantsIdGuidActivateMutationError = unknown;

export const usePortalPostPortalMerchantsIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalMerchantsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalMerchantsIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalMerchantsMerchantIdGuidStores = (
  merchantId: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreSummaryDto[]>(
    { url: `/portal/merchants/${merchantId}/stores`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalMerchantsMerchantIdGuidStoresQueryKey = (merchantId?: string) => {
  return [`/portal/merchants/${merchantId}/stores`] as const;
};

export const getPortalGetPortalMerchantsMerchantIdGuidStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPortalGetPortalMerchantsMerchantIdGuidStoresQueryKey(merchantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>
  > = ({ signal }) =>
    portalGetPortalMerchantsMerchantIdGuidStores(merchantId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!merchantId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalMerchantsMerchantIdGuidStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>
>;
export type PortalGetPortalMerchantsMerchantIdGuidStoresQueryError = unknown;

export function usePortalGetPortalMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalMerchantsMerchantIdGuidStores<
  TData = Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
  TError = unknown,
>(
  merchantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof portalGetPortalMerchantsMerchantIdGuidStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalMerchantsMerchantIdGuidStoresQueryOptions(
    merchantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPostPortalMerchantsMerchantIdGuidStores = (
  merchantId: string,
  createStoreRequest: CreateStoreRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    {
      url: `/portal/merchants/${merchantId}/stores`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createStoreRequest,
      signal,
    },
    options,
  );
};

export const getPortalPostPortalMerchantsMerchantIdGuidStoresMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>,
    TError,
    { merchantId: string; data: CreateStoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>,
  TError,
  { merchantId: string; data: CreateStoreRequest },
  TContext
> => {
  const mutationKey = ['portalPostPortalMerchantsMerchantIdGuidStores'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>,
    { merchantId: string; data: CreateStoreRequest }
  > = (props) => {
    const { merchantId, data } = props ?? {};

    return portalPostPortalMerchantsMerchantIdGuidStores(merchantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalMerchantsMerchantIdGuidStoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>
>;
export type PortalPostPortalMerchantsMerchantIdGuidStoresMutationBody = CreateStoreRequest;
export type PortalPostPortalMerchantsMerchantIdGuidStoresMutationError =
  HttpValidationProblemDetails;

export const usePortalPostPortalMerchantsMerchantIdGuidStores = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>,
      TError,
      { merchantId: string; data: CreateStoreRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalMerchantsMerchantIdGuidStores>>,
  TError,
  { merchantId: string; data: CreateStoreRequest },
  TContext
> => {
  const mutationOptions = getPortalPostPortalMerchantsMerchantIdGuidStoresMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalStoresIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    { url: `/portal/stores/${id}`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalStoresIdGuidQueryKey = (id?: string) => {
  return [`/portal/stores/${id}`] as const;
};

export const getPortalGetPortalStoresIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalStoresIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>> = ({
    signal,
  }) => portalGetPortalStoresIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalStoresIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>
>;
export type PortalGetPortalStoresIdGuidQueryError = unknown;

export function usePortalGetPortalStoresIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalStoresIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalStoresIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalStoresIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalStoresIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalStoresIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPutPortalStoresIdGuid = (
  id: string,
  updateStoreRequest: UpdateStoreRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<StoreDetailDto>(
    {
      url: `/portal/stores/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateStoreRequest,
    },
    options,
  );
};

export const getPortalPutPortalStoresIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>,
    TError,
    { id: string; data: UpdateStoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>,
  TError,
  { id: string; data: UpdateStoreRequest },
  TContext
> => {
  const mutationKey = ['portalPutPortalStoresIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>,
    { id: string; data: UpdateStoreRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return portalPutPortalStoresIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPutPortalStoresIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>
>;
export type PortalPutPortalStoresIdGuidMutationBody = UpdateStoreRequest;
export type PortalPutPortalStoresIdGuidMutationError = HttpValidationProblemDetails;

export const usePortalPutPortalStoresIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>,
      TError,
      { id: string; data: UpdateStoreRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPutPortalStoresIdGuid>>,
  TError,
  { id: string; data: UpdateStoreRequest },
  TContext
> => {
  const mutationOptions = getPortalPutPortalStoresIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalStoresIdGuidSuspend = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    { url: `/portal/stores/${id}/suspend`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalStoresIdGuidSuspendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalStoresIdGuidSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalStoresIdGuidSuspend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalStoresIdGuidSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>
>;

export type PortalPostPortalStoresIdGuidSuspendMutationError = unknown;

export const usePortalPostPortalStoresIdGuidSuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalStoresIdGuidSuspendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalStoresIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StoreDetailDto>(
    { url: `/portal/stores/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalStoresIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalStoresIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalStoresIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalStoresIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>
>;

export type PortalPostPortalStoresIdGuidActivateMutationError = unknown;

export const usePortalPostPortalStoresIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalStoresIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalStoresIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalUsers = (
  params?: PortalGetPortalUsersParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfPortalClientUserDto>(
    { url: `/portal/users`, method: 'GET', params, signal },
    options,
  );
};

export const getPortalGetPortalUsersQueryKey = (params?: PortalGetPortalUsersParams) => {
  return [`/portal/users`, ...(params ? [params] : [])] as const;
};

export const getPortalGetPortalUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalUsers>>,
  TError = unknown,
>(
  params?: PortalGetPortalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalUsers>>> = ({ signal }) =>
    portalGetPortalUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalUsers>>
>;
export type PortalGetPortalUsersQueryError = unknown;

export function usePortalGetPortalUsers<
  TData = Awaited<ReturnType<typeof portalGetPortalUsers>>,
  TError = unknown,
>(
  params: undefined | PortalGetPortalUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsers>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsers<
  TData = Awaited<ReturnType<typeof portalGetPortalUsers>>,
  TError = unknown,
>(
  params?: PortalGetPortalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsers>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsers<
  TData = Awaited<ReturnType<typeof portalGetPortalUsers>>,
  TError = unknown,
>(
  params?: PortalGetPortalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalUsers<
  TData = Awaited<ReturnType<typeof portalGetPortalUsers>>,
  TError = unknown,
>(
  params?: PortalGetPortalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPostPortalUsers = (
  inviteClientUserRequest: InviteClientUserRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<InviteClientUserResult>(
    {
      url: `/portal/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteClientUserRequest,
      signal,
    },
    options,
  );
};

export const getPortalPostPortalUsersMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalUsers>>,
    TError,
    { data: InviteClientUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalUsers>>,
  TError,
  { data: InviteClientUserRequest },
  TContext
> => {
  const mutationKey = ['portalPostPortalUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalUsers>>,
    { data: InviteClientUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return portalPostPortalUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalUsers>>
>;
export type PortalPostPortalUsersMutationBody = InviteClientUserRequest;
export type PortalPostPortalUsersMutationError = HttpValidationProblemDetails;

export const usePortalPostPortalUsers = <TError = HttpValidationProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalUsers>>,
      TError,
      { data: InviteClientUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalUsers>>,
  TError,
  { data: InviteClientUserRequest },
  TContext
> => {
  const mutationOptions = getPortalPostPortalUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalUsersIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalClientUserDto>(
    { url: `/portal/users/${id}`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalUsersIdGuidQueryKey = (id?: string) => {
  return [`/portal/users/${id}`] as const;
};

export const getPortalGetPortalUsersIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalUsersIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>> = ({
    signal,
  }) => portalGetPortalUsersIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalUsersIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>
>;
export type PortalGetPortalUsersIdGuidQueryError = unknown;

export function usePortalGetPortalUsersIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsersIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsersIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalUsersIdGuid<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalUsersIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPutPortalUsersIdGuid = (
  id: string,
  updateClientUserRequest: UpdateClientUserRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<PortalClientUserDto>(
    {
      url: `/portal/users/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateClientUserRequest,
    },
    options,
  );
};

export const getPortalPutPortalUsersIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>,
    TError,
    { id: string; data: UpdateClientUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>,
  TError,
  { id: string; data: UpdateClientUserRequest },
  TContext
> => {
  const mutationKey = ['portalPutPortalUsersIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>,
    { id: string; data: UpdateClientUserRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return portalPutPortalUsersIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPutPortalUsersIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>
>;
export type PortalPutPortalUsersIdGuidMutationBody = UpdateClientUserRequest;
export type PortalPutPortalUsersIdGuidMutationError = HttpValidationProblemDetails;

export const usePortalPutPortalUsersIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>,
      TError,
      { id: string; data: UpdateClientUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPutPortalUsersIdGuid>>,
  TError,
  { id: string; data: UpdateClientUserRequest },
  TContext
> => {
  const mutationOptions = getPortalPutPortalUsersIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalUsersIdGuidDeactivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalClientUserDto>(
    { url: `/portal/users/${id}/deactivate`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalUsersIdGuidDeactivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalUsersIdGuidDeactivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalUsersIdGuidDeactivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalUsersIdGuidDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>
>;

export type PortalPostPortalUsersIdGuidDeactivateMutationError = unknown;

export const usePortalPostPortalUsersIdGuidDeactivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalUsersIdGuidDeactivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalPostPortalUsersIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalClientUserDto>(
    { url: `/portal/users/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalUsersIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalUsersIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalUsersIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalUsersIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>
>;

export type PortalPostPortalUsersIdGuidActivateMutationError = unknown;

export const usePortalPostPortalUsersIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalUsersIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalUsersIdGuidSessions = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalSessionDto[]>(
    { url: `/portal/users/${id}/sessions`, method: 'GET', signal },
    options,
  );
};

export const getPortalGetPortalUsersIdGuidSessionsQueryKey = (id?: string) => {
  return [`/portal/users/${id}/sessions`] as const;
};

export const getPortalGetPortalUsersIdGuidSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalUsersIdGuidSessionsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>> = ({
    signal,
  }) => portalGetPortalUsersIdGuidSessions(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalUsersIdGuidSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>
>;
export type PortalGetPortalUsersIdGuidSessionsQueryError = unknown;

export function usePortalGetPortalUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalUsersIdGuidSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalUsersIdGuidSessionsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalPostPortalUsersIdGuidSessionsRevokeAll = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<unknown>(
    { url: `/portal/users/${id}/sessions/revoke-all`, method: 'POST', signal },
    options,
  );
};

export const getPortalPostPortalUsersIdGuidSessionsRevokeAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalPostPortalUsersIdGuidSessionsRevokeAll'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalPostPortalUsersIdGuidSessionsRevokeAll(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalPostPortalUsersIdGuidSessionsRevokeAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>
>;

export type PortalPostPortalUsersIdGuidSessionsRevokeAllMutationError = unknown;

export const usePortalPostPortalUsersIdGuidSessionsRevokeAll = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalPostPortalUsersIdGuidSessionsRevokeAll>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalPostPortalUsersIdGuidSessionsRevokeAllMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalGetPortalTransactions = (
  params?: PortalGetPortalTransactionsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfTransactionSummaryDto>(
    { url: `/portal/transactions`, method: 'GET', params, signal },
    options,
  );
};

export const getPortalGetPortalTransactionsQueryKey = (
  params?: PortalGetPortalTransactionsParams,
) => {
  return [`/portal/transactions`, ...(params ? [params] : [])] as const;
};

export const getPortalGetPortalTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalGetPortalTransactions>>,
  TError = unknown,
>(
  params?: PortalGetPortalTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalTransactions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalGetPortalTransactionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalGetPortalTransactions>>> = ({
    signal,
  }) => portalGetPortalTransactions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalGetPortalTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalGetPortalTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalGetPortalTransactions>>
>;
export type PortalGetPortalTransactionsQueryError = unknown;

export function usePortalGetPortalTransactions<
  TData = Awaited<ReturnType<typeof portalGetPortalTransactions>>,
  TError = unknown,
>(
  params: undefined | PortalGetPortalTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalTransactions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalTransactions>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalTransactions<
  TData = Awaited<ReturnType<typeof portalGetPortalTransactions>>,
  TError = unknown,
>(
  params?: PortalGetPortalTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalTransactions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalGetPortalTransactions>>,
          TError,
          Awaited<ReturnType<typeof portalGetPortalTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalGetPortalTransactions<
  TData = Awaited<ReturnType<typeof portalGetPortalTransactions>>,
  TError = unknown,
>(
  params?: PortalGetPortalTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalTransactions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalGetPortalTransactions<
  TData = Awaited<ReturnType<typeof portalGetPortalTransactions>>,
  TError = unknown,
>(
  params?: PortalGetPortalTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalGetPortalTransactions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalGetPortalTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
